import {SODeleteAttributeSpec} from '../../core/attribute-spec/so-delete-attribute-spec';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteAttributeSpec extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteAttributeSpec;
}